import React from "react";

const Contact = () => {
  return (
  <>
    <section className="contact">
      <div className="container">
        <div className="row">
          {/* Información de contacto */}
          <div className="col-lg-6 d-flex flex-column gap-3">
            <div className="info-box">
            <i className="bi bi-geo-alt"></i> {/* Icono de mapa */}
              <h3>Dirección</h3>
              <p>Calle 30 N°940 e/127 y 128, Berisso partido de La Plata, Buenos Aires</p>
            </div>
            <div className="info-box-container">
              <div className="info-box">
                <i className="bi bi-envelope"></i> {/* Icono de correo */}
                <h3>Email</h3>
                <a href="mailto:marcos--1@Live.com.ar?subject=Consulta&body=
                  Hola, quiero solicitar más información sobre los productos o servicios que ofrecen.">
                  marcos--1@Live.com.ar
                </a>
              </div>
            
              <div className="info-box">
                <i className="bi bi-phone"></i> {/* Icono de teléfono */}
                <h3>Teléfono</h3>
                <a href="tel:+5492213533791">Cel: (0221) 3533791</a>
                
              </div>
          </div>
          </div>
          {/* Mapa */}
          <div className="col-lg-6">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.2815381390533!2d-57.89337898897547!3d-34.92447547439502!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a2ef69a7c3a429%3A0x788f7c3f646da949!2sC.%2030%20940%2C%20B1924%20Berisso%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1ses-419!2sar!4v1732586419844!5m2!1ses-419!2sar" 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>
    </section>
    {/* Botón flotante de WhatsApp */}
    <div className="btn-whatsapp">
      <a href="https://api.whatsapp.com/send?phone=2213533791" target="_blank" rel="noopener noreferrer">
        <img src="/whatsapp.svg" alt="WhatsApp" />
      </a>
    </div>
  </>
  );
};

export default Contact;
